// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__3MfzK","modal":"Modal_modal__YwX8Y","header":"Modal_header__CBqFj","close":"Modal_close__1mg60","scrollable":"Modal_scrollable__I5-o4"};